import * as fromDatatype from '../datatype-library/index';

export interface bl_cms_website_user_agreement_document_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    agreement_type: fromDatatype.VarcharArrayDatatypeInterface;
    document_vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    document_code: fromDatatype.VarcharArrayDatatypeInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    enable_auto_switch: boolean;
    ZonedDateTime: fromDatatype.TimestampTzDatatypeInterface;
    object_type: fromDatatype.CmsWebsiteUserAgreementDocumentHdrObjectTypeConstant;
    policy_expiry: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_cms_website_user_agreement_document_hdr_RowClass implements bl_cms_website_user_agreement_document_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    agreement_type: fromDatatype.VarcharArrayDatatypeInterface;
    document_vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    document_code: fromDatatype.VarcharArrayDatatypeInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    enable_auto_switch: boolean;
    ZonedDateTime: fromDatatype.TimestampTzDatatypeInterface;
    object_type: fromDatatype.CmsWebsiteUserAgreementDocumentHdrObjectTypeConstant;
    policy_expiry: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}